import {
  CarrierSpecificClaimInfoSchema,
  ShippingClaimPhotoSchema,
  ShippingClaimReason,
} from "@redotech/redo-model/shipping-claims/shipping-claim";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const submitReturnShippingClaim = {
  name: "submitReturnShippingClaim" as const,
  input: z.object({
    returnId: zExt.objectId(),
    shipmentId: z.string(),
    reason: createEnum(ShippingClaimReason),
    photos: z.array(ShippingClaimPhotoSchema).nullish(),
    notes: z.string().optional(),
    carrierSpecificInfo: CarrierSpecificClaimInfoSchema.nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    claimId: z.string(),
    message: z.string(),
  }),
};
